import { Component, OnInit, Input } from '@angular/core';
import { LabelProps } from 'recharts';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label } from 'ng2-charts';
import { OverallPerformanceForecastVO } from 'src/app/planner/interfaces/vo/OverallPerformanceForecastVO';
import { GoalForeCastResultVO } from 'src/app/planner/interfaces/vo/GoalForeCastResultVO';
import { PlanConfigVO } from 'src/app/planner/interfaces/vo/PlanConfigVO';

@Component({
  selector: 'performance-forecast',
  templateUrl: './performance-forecast.component.html',
  styleUrls: ['./performance-forecast.component.scss']
})
export class PerformanceForecastComponent implements OnInit {

  @Input() public overallPerformanceForecastData: OverallPerformanceForecastVO;
  @Input() public goalPerformanceForeCastData: GoalForeCastResultVO;
  @Input() public planDetails: PlanConfigVO;

  // Doughnut
  public doughnutChartLabels: Label[] = ['Allocated', 'Remaining'];
  public doughnutChartData: MultiDataSet;
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartColors: any[] =
    [
      {
        backgroundColor: ['#009ebd', '#E2E2E2']
      }
    ]
  public keys = [{ dataKey: 'requested' }, { dataKey: 'forecasted' }];
  public colors = ['#E2E2E2', '#009ebd'];
  public chartOptions = {
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.labels[tooltipItem.index];
          let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          return ' ' + label + ': ' + value.toFixed(2);
        }
      },
      yAlign: 'top',
      xAlign: 'center'
    },
    legend: false,
    responsive: true
  }
  public dataLabel: LabelProps = {
    position: 'center',
    formatter: (e) => this.toPercentage(e)
  };

  public mainXAxis = [{
    dataKey: 'type',
    tick: { fontSize: 11 }
  }];

  public mainYAxis = [
    {
      dataKey: 'requested',
      tick: { fontSize: 11 },
      ticks: [0, 25, 50, 75, 100],
      width: 50,
      onTickFormatter: (e) => this.toPercentage(e)
    },
    {
      dataKey: 'forecasted',
      tick: { fontSize: 11 },
      onTickFormatter: (e) => this.toPercentage(e)
    }
  ];

  toPercentage(number: number): string {
    return number + '%';
  }

  constructor() {
  }

  ngOnInit() {
    this.doughnutChartData = [
      [this.overallPerformanceForecastData.totalBudget, this.overallPerformanceForecastData.flightSchedule.spendingCap - this.overallPerformanceForecastData.totalBudget]
    ];
  }

}
